var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checked)?_c('mail-registration-verification',{attrs:{"success":_vm.success},on:{"to-artist":_vm.handleToArtist}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }